// extracted by mini-css-extract-plugin
export default {"container":"artwork-received_container__YfAkZ","greenButton":"artwork-received_greenButton__FygyR"};